/**
 * RangePicker — segmented control over the supported analytics windows. The
 * value is the same token the backend understands (`7d`, `30d`, ...), so we
 * stay aligned without a translation layer.
 */

import * as React from 'react'
import { cn } from '@/src/infrastructure/lib/utils'
import type { AnalyticsRange } from '../types'

interface Props {
  value: AnalyticsRange
  onChange: (next: AnalyticsRange) => void
}

const OPTIONS: { value: AnalyticsRange; label: string }[] = [
  { value: '7d', label: '7d' },
  { value: '30d', label: '30d' },
  { value: '90d', label: '90d' },
  { value: '6m', label: '6m' },
  { value: '12m', label: '12m' },
]

export function RangePicker({ value, onChange }: Props) {
  return (
    <div
      role="radiogroup"
      aria-label="Analytics range"
      className="inline-flex items-center gap-1 p-1 bg-surface-low rounded-xl border border-outline-variant/30 self-start"
    >
      {OPTIONS.map((opt) => {
        const active = opt.value === value
        return (
          <button
            key={opt.value}
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt.value)}
            className={cn(
              'px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors',
              active
                ? 'bg-primary text-white shadow-sm'
                : 'text-on-surface-variant hover:bg-outline-variant/20',
            )}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
